/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { ComponentGalleryItemContext } from "./component-gallery-context";
import { ImageSelectorWrapper } from "cms/images/image-selector/image-selector-wrapper";
import { isObject, isGuid } from "utils/empty-exists";

const ImageGalleryItemEditor = () => {

    const { token } = useAuth();
    const {
        position,
        item,
        updateItemByPosition,
        removeItem,
        onReload,
    } =  useContext(ComponentGalleryItemContext);
    const { image: itemImage } = item || {};
    const [image, setImage] = useState();
    // const [imageGuid, setImageGuid] = useState()
    // const [loadingImage, setLoadingImage] = useState(false)

    const loadImage = async () => {
        if (item?.image && item?.image.length > 30) {
            const _image = await SimpliCityAdminSDK.image.findOne(token, item?.image);
            setImage(_image);
            return _image;
        }
    };

    useEffect(() => {
        const load = async () => {
            if (isGuid(itemImage)) {
                // setLoadingImage(true)
                const _image = await loadImage(itemImage);
                // setImageGuid(_image?.guid)
                setImage(_image);
                // setLoadingImage(false)
            }
        };
        // load once
        // if (!isObject(image) || !objectHasPropertyString(image, 'guid') || image?.image !== item?.image) {
        if (!isObject(image) || isGuid(itemImage)) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item]);

    const updateImage = (guid) => {
        if (!guid) {
            guid = "";
        }
        const newItem = structuredClone({ ...item, image: guid });
        updateItemByPosition(newItem, position);
    };

    const onImageChange = async (changeImg) => {
        setImage(changeImg);
        // setImageGuid(changeImg?.guid)
        if (isGuid(changeImg?.guid)) {
            await updateImage(changeImg?.guid);
        }
    };
    const onImageSave = async () => {};
    const onImageRemove = async () => {
        setImage(null);
        updateImage("");
        removeItem(position);
    };

    return (
        <div className='simplicity-image-list-item' style={{ width: "100%" }}>
            <Stack direction='row' justifyContent='flex-start'>
                <div className='simplicity-image-list-item-data' style={{ width: "100%" }}>
                    <div style={{ width: "100%" }}>
                        <ImageSelectorWrapper
                            image={image}
                            onImageChange={(_image) => onImageChange(_image)}
                            onImageSave={(_image) => onImageSave(_image)}
                            onImageRemove={(_image) => onImageRemove(_image)}
                            onReload={onReload}
                            className="gallery-image-editor"
                        />
                    </div>
                </div>
            </Stack>
        </div>
    );
};

ImageGalleryItemEditor.displayName = "ImageGalleryItemEditor";
export { ImageGalleryItemEditor };
